import { api } from 'app/api';
import { ApiResponse, LaborClassificationDto, LaborClassificationsParameters } from 'dtos';
import { URIQuery } from 'utils';

export const getLaborClassifications = async (
  parameters: LaborClassificationsParameters
): Promise<ApiResponse<LaborClassificationDto[]>> =>
  await api.get('labor-classifications' + URIQuery(parameters)).then(res => res.data);

export const getAllLaborClassifications = async (
  jobNumber?: string,
  formId?: number
): Promise<ApiResponse<LaborClassificationDto[]>> => {
  let url = 'labor-classifications/all' + URIQuery({ jobNumber, formId });

  return await api.get(url).then(res => res.data);
};

export const createLaborClassification = async (values: LaborClassificationDto): Promise<ApiResponse<LaborClassificationDto>> =>
  await api.post<ApiResponse<LaborClassificationDto>>('labor-classifications', values).then(res => res.data);

export const updateLaborClassification = async (values: LaborClassificationDto): Promise<ApiResponse<LaborClassificationDto>> =>
  await api.put<ApiResponse<LaborClassificationDto>>('labor-classifications', values).then(res => res.data);
